<template>
  <auth-layout pageClass="register-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8">
        <div class="header-text">
          <img class="customLogo" src="/static/img/logo.png" alt="avatar"/>
          <h4>Captive Portal - OTP</h4>
          <hr>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12 mx-auto">

        <card v-if="step==='one'">

            <form @submit.prevent="submit()">

              <ValidationProvider
                  name="Name"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
                <fg-input  type="text"
                          :error="failed ? 'The Name field is required': null"
                          :hasSuccess="passed"
                          label="Name"
                          name="Name"
                          v-model="name">
                </fg-input>        
              </ValidationProvider>


              <ValidationProvider
                  name="Mobile"
                  rules="required"
                  v-slot="{ passed, failed }"
                >
              <fg-input  type="text"
                        :error="failed ? 'The Mobile Number field is required': null"
                        :hasSuccess="passed"
                        label="Mobile Number"
                        v-model="mobilenumber"
                        >    


              </fg-input>
              </ValidationProvider>

                   <VuePhoneNumberInput name="Mobile" v-model="mobilenumber" default-country-code="PH" :only-countries="['PH']" clearable  :translations="this.translations"/>             

              <div class="d-flex justify-content-center p-4">
                <button type="submit" class="btn btn-fill btn-info btn-wd">Submit</button>
              </div>

            </form>


        </card>

        <card v-else-if="step === 'two'">
            <div class="d-flex justify-content-center">
              <h5>One Time Password:</h5>
            </div>

            <div class="d-flex justify-content-center p-4">
              <PincodeInput
                v-model="otp"
                :length=6
              />
            </div>

            <div class="d-flex justify-content-center p-4">
              <button type="submit" :disabled="resendDisabled" class="btn btn-fill btn-info btn-wd m-2" @click="resendOTP()">Resend OTP</button>
              <button type="submit" class="btn btn-fill btn-info btn-wd m-2" @click="submitOTP()">Submit</button>
            </div>

            <div class="d-flex justify-content-center">
              <h6>Resend in: {{ minutes }}m {{ seconds }}s</h6>
            </div>

        </card>

        <card v-else-if="step === 'three'">
          <div class="d-flex justify-content-center">
            <h3><i class="nc-icon nc-check-2"></i> Verification Successful</h3>
          </div>
          <div class="d-flex justify-content-center">
            <h5>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </h5>
          </div>
        </card>
        
      </div>
      
    </div>
  </auth-layout>
</template>
<script>
  import AuthLayout from './AuthLayout.vue'
  import PincodeInput from 'vue-pincode-input';

  import VuePhoneNumberInput from 'vue-phone-number-input';
  import 'vue-phone-number-input/dist/vue-phone-number-input.css';

  import { extend } from "vee-validate";
  import { required, email, min } from "vee-validate/dist/rules";

extend("email", email);
extend("required", required);
extend("min", min);


  export default {
    components: {
      AuthLayout,
      PincodeInput,
      VuePhoneNumberInput
    },
     data () {
      return {
        name: "",
        mobilenumber: "",
        step: 'one',
        otp: "",
        remainingTime: 60 * 5,
        timerInterval: null,
        resendDisabled: true,
        translations: {
          phoneNumberLabel: '',
        }
      }
    },
    watch: {
      remainingTime(newVal) {
        if (newVal <= 0) {
          this.clearInterval();
        }
      },
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      async submit() { 

          this.step = "two";
          this.startTimer();

      },
      async startTimer() {
        //this.resendDisabled = true;
        this.timerInterval = setInterval(() => {
          if (this.remainingTime > 0) {
            this.remainingTime--;
          } else {
            this.resendDisabled = false;
            this.clearTimer();
          }
        }, 1000);
      },
      async clearTimer() {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      },
      async resendOTP() {
        // Implement resend code logic here
        if (this.remainingTime <= 0) {
          // Reset timer
          this.remainingTime = 60 * 5;
          this.startTimer();
        }
      },

      async submitOTP() {
        this.step = "three";
      }


    },
    beforeDestroy () {
      this.closeMenu()
    },
    computed: {
      minutes() {
        return Math.floor(this.remainingTime / 60);
      },
      seconds() {
        return this.remainingTime % 60;
      },
    },
  }
</script>
<style>

.customLogo {
  width: 18em
}

</style>
